var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select", class: { "select--active": _vm.visible } },
    [
      !_vm.visible
        ? _c("div", {
            staticClass: "select__wrapper",
            domProps: { textContent: _vm._s(_vm.text) },
            on: {
              click: function($event) {
                _vm.visible = !_vm.visible
              }
            }
          })
        : _vm._e(),
      _vm._t("default", null, {
        value: _vm.value,
        update: _vm.changelang,
        visible: _vm.visible
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a117cf1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a117cf1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/select/select.vue
// module id = 186
// module chunks = 4